import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Paper, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ToastContainer } from "react-toastify";
import Typography from "@mui/material/Typography";

function contactUs(props) {
  return (
    <Grid container sx={{ textAlign: "justify", height: "100vh" }}>
      <Paper
        sx={{
          m: 1,
          height: "50%",
          width: "70%",
          borderRadius: " 15px",
          fontWeight: "bold",
          p: 1,
          border: 2,
          borderColor: "secondary.main",
        }}
      >
        <Typography>تلفن تماس:</Typography>
        <Typography>09216065530</Typography>
        <Typography>09380351693</Typography>
        <Typography>Email:</Typography>
        <Typography>umlang.info@gmail.com</Typography>
        <hr />
        <Typography>آدرس:</Typography>
        <Typography>
          خراسان شمالی ، جاجرم ، خیابان شهید بهشتی ، بشهتی 18 ، پلاک 3 طبقه همکف
        </Typography>
      </Paper>
    </Grid>
  );
}

export default contactUs;
